import { arrayUtil } from "../utils";

const isMultiselectFieldChanged = (appliedField, selectedField) => {
  return (
    (appliedField?.length &&
      !arrayUtil.arrayEquals(
        appliedField?.map((m) => m.id),
        selectedField?.map((m) => m.id)
      )) ||
    (!appliedField && selectedField?.length && !selectedField?.map((m) => m.id)?.includes(0))
  );
};

const isDeviceChanged = (device, selectedDevice) => {
  return (device && device?.id !== selectedDevice?.id) || (!device && selectedDevice?.id !== 0);
};

const dashboardFiltersUtil = { isMultiselectFieldChanged, isDeviceChanged };

export default dashboardFiltersUtil;
